// Plan of care section form field enum
export enum PlanOfCareFormField {
  GOALS = 'plan-of-care/goals',
  INTERVENTIONS = 'plan-of-care/patient-interventions',
  INITIALS_AUTHORIZATION = 'plan-of-care/initials-authorization'
}
